(function () {
    'use strict';

    a3_cabin_reports.factory('ToolkitFactory', ToolkitFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name ToolkitFactory
     * @description 
     *   Add, Update, Delete and Get Memos.
     * @ngInject
     */
    function ToolkitFactory(IndexedDBService) {

        /**
         * Initialize the Toolkit Item
         * @memberof ToolkitFactory
         */
        function ToolkitItem() {
            this.Id = null;
        }

        var objType = 'ToolkitItems';
        var objCallback = ToolkitItem;

        var service = {
            setToolkitItemsFromServer : setToolkitItemsFromServer,
            getToolkitItemsFromStorage : getToolkitItemsFromStorage,
            setToolkitItemsToStorage : setToolkitItemsToStorage,
            saveToolkitItemToStorage : saveToolkitItemToStorage,
            addToolkitItemToStorage : addToolkitItemToStorage
        };

         /**
         * Set ToolkitItems from server API  
         * @memberof ToolkitFactory
         * @param {array} toolkitItems ToolkitItems Object
         */
        function setToolkitItemsFromServer(toolkitItems) {

            //Manually add 'No Treatment' option
            toolkitItems.forEach(function(item){
                item.Treatments.push({
                    Id: -1,
                    PaxCategory: 0,
                    Title: "No Treatment",
                    Description: "",
                    Type: "",
                    Comments: null,
                    ToolkitItemId: item.Id,
                });
            });

            getToolkitItemsFromStorage(function(localToolkitItems){
                // No Toolkit Items found - Save All Incoming
                if (!localToolkitItems || localToolkitItems.length == 0) {
                    setToolkitItemsToStorage(toolkitItems);
                } 
                else 
                {
                    for (var j = 0; j < toolkitItems.length; j++) {
                        var isToolkitItemIncluded = false;

                        for (var h = 0; h < localToolkitItems.length; h++) {
                            if (toolkitItems[j].Id == localToolkitItems[h].Id) {
                                isToolkitItemIncluded = true;
                                break; 
                            }
                        }     
                        
                        //Update
                        if (isToolkitItemIncluded) {
                            saveToolkitItemToStorage(toolkitItems[j]);
                        } 
                        //Add 
                        else {
                            addToolkitItemToStorage(toolkitItems[j]);
                        }
                    }
                    
                    localToolkitItems.filter(x=> !toolkitItems.some(z=>z.Id == x.Id)).forEach(function(item){
                        IndexedDBService.remove(objType,item.Id)
                    })
              } 
            })
        }

         /**
          * Get Toolkit Items
          * @memberof ToolkitFactory
          * @param {*} callback 
          */
        function getToolkitItemsFromStorage(callback) {
            IndexedDBService.getAll(objType).then(function (results) {
                callback(results);
            });
        }

        /**
         * Set Toolkit Items
         * @memberof ToolkitFactory
         * @param {array} ToolkitItems A list of Toolkit Items to set to indexedDB
         */
        function setToolkitItemsToStorage(ToolkitItems, callback, errorCallback) {
            IndexedDBService.addAll(objType, ToolkitItems).then(callback).catch(errorCallback);;
        };

        /**
         * Add Toolkit Item to Storage
         * @memberof ToolkitFactory
         * @param {object} ToolkitItem
         */
        function addToolkitItemToStorage(ToolkitItem, callback, errorCallback) {
            IndexedDBService.add(objType, ToolkitItem).then(callback).catch(errorCallback);
        };

        /**
         * Update Toolkit Item in Storage
         * @memberof ToolkitFactory
         * @param {object} ToolkitItem
         */
        function saveToolkitItemToStorage(ToolkitItem, callback, errorCallback) {
            IndexedDBService.put(objType, ToolkitItem).then(callback).catch(errorCallback);
        };

        return service;
    }
})();
